var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{'element-hidden': !_vm.visability('form')},style:({..._vm.fullPaddingSubject(_vm.section.options.content.form), ..._vm.fullMarginSubject(_vm.section.options.content.form)})},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }